import { BasePolyfill } from './BasePolyfill';

class FormData extends BasePolyfill {
  public execute = true;
  public polyfill = () => require('formdata-polyfill');
}

export { FormData };
